import { render, staticRenderFns } from "./EntryTableBulkActions.vue?vue&type=template&id=2cedefdb&scoped=true&"
import script from "./EntryTableBulkActions.vue?vue&type=script&lang=ts&"
export * from "./EntryTableBulkActions.vue?vue&type=script&lang=ts&"
import style0 from "./EntryTableBulkActions.vue?vue&type=style&index=0&id=2cedefdb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cedefdb",
  null
  
)

export default component.exports